// eslint-disable-next-line @typescript-eslint/no-unused-vars
import styles from './app.module.css';

import { AppRouter } from '../routes/appRouter';

export function App() {
  return <AppRouter />;
}

export default App;
